module.exports = __webpack_public_path__ + "media/images/pc/specials/fair/title_ribbon_02-24089e976e1a91827248bd2b89592b7c.png";